import React, { useEffect, useRef } from "react";
import { Stage, Layer, Image as KonvaImage, Group } from "react-konva";
import { socket } from "../../io";


const Sorteo = ({
  width = Math.floor(window.visualViewport?.width || window.innerWidth),
  height = Math.floor(window.visualViewport?.height || window.innerHeight),
  file = "",
  onReady, // 👈 callback cuando el video está listo y ya se puede mostrar
}) => {
  const layerRef = useRef(null);
  const konvaImageRef = useRef(null);

  const videoRef = useRef(null);
  const rafRef = useRef(0);
  const currentAbsSrcRef = useRef("");
  const readySentRef = useRef(false);

  const normalize = (src) => new URL(src, window.location.href).href;

  const stopLoop = () => {
    if (rafRef.current) cancelAnimationFrame(rafRef.current);
    rafRef.current = 0;
  };

  const startLoop = () => {
    stopLoop();
    const tick = () => {
      const v = videoRef.current;
      if (!v || v.paused || v.ended) return stopLoop();
    if(layerRef && layerRef.current)  layerRef.current.batchDraw();
      rafRef.current = requestAnimationFrame(tick);
    };
    tick();
  };

  const setSourceIfChanged = (src) => {
    const v = videoRef.current;
    if (!v) return;

    const abs = normalize(src);
    if (currentAbsSrcRef.current === abs) return; // MISMO => NO reinicia

    currentAbsSrcRef.current = abs;
    readySentRef.current = false;

    v.pause();
    v.src = src;         // cambia la fuente
    v.currentTime = 0;   // arranca desde 0 SOLO cuando cambia el video
    v.load();            // importante para asegurar canplay
  };

  // Crear video UNA VEZ
  useEffect(() => {
    const v = document.createElement("video");
    v.muted = true;
    v.playsInline = true;
    v.loop = true;
    v.preload = "auto";

    const onCanPlay = async () => {
      try {
        await v.play();
        startLoop();

        // 📌 dispara onReady 1 sola vez por video cargado
        if (!readySentRef.current) {
          readySentRef.current = true;
        if (typeof onReady === "function") onReady();

        }
      } catch {
        // autoplay bloqueado (raro si muted, pero posible)
      }
    };

    v.addEventListener("canplay", onCanPlay);

    videoRef.current = v;
    if(konvaImageRef) konvaImageRef.current.image(v);

    // carga inicial
    setSourceIfChanged(`/videos/${file}`);

    return () => {
      stopLoop();
      v.removeEventListener("canplay", onCanPlay);
      v.pause();
      v.src = "";
      v.load();

      videoRef.current = null;
      currentAbsSrcRef.current = "";
      readySentRef.current = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Socket listener UNA VEZ
  useEffect(() => {
    const onVideo = (vd) => {
      const name = vd?.video || vd; // por si te llega string directo
      const next = String(name || "");
      if (!next) return;
      setSourceIfChanged(next.startsWith("/") || next.startsWith("http") ? next : `/videos/${next}`);
    };

    socket.on("video", onVideo);
    return () => socket.off("video", onVideo);
  }, []);

  return (
    <Stage width={width} height={height}>
      <Layer ref={layerRef}>
        <Group x={0} y={0} width={width} height={height}>
          <KonvaImage ref={konvaImageRef} x={0} y={0} width={width} height={height} />
        </Group>
      </Layer>
    </Stage>
  );
};

export default Sorteo;
